/* eslint-disable no-mixed-spaces-and-tabs */
import { datetimeCovertertolocal } from '../../datetime-converter';
import { INCIDENT_LIST, INCIDENT_LIST_DETAILS, INCIDENT_LIST_DETAILS_ERROR, INCIDENT_LIST_DETAILS_SUCCESS, INCIDENT_LIST_ERROR, INCIDENT_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS } from './constants';


export default function incidentre(state, action) {

	let incidents = [];
	let pagination = {};

	switch (action.type) {
      
	case INCIDENT_LIST:
		return { ...state, pending: true };
                
	case INCIDENT_LIST_SUCCESS:
                
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			if (action.payload) {
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
                    
			}
    
			action.payload.data.forEach((item) => {
				const dateTime = datetimeCovertertolocal(item.dateTime?item.dateTime : '<Not Set>');
				const newDatetime = item.dateTime ? (dateTime.localdate + ' ' + dateTime.localtime) : '<Not Set>';
                    
				incidents.push({
					id : item?.id,
					name:item?.name?item.name:'No Data',
					dateTime: newDatetime,
					utc_time:item?.dateTime ?  item?.dateTime : '',
					allocationId:item?.allocationId?item.allocationId:null,
					userId:item?.userId?item.userId: null,
					attachmentUrls:item?.attachmentUrls,
					remarks:item?.remarks ? item?.remarks : 'No Data' ,
					pipelineId: item?.pipelineId ?  item?.pipelineId : null,
					userName : item?.users? item?.users?.firstName + ' ' + item?.users?.lastName :'No Data',
					allocation : item?.userallocation ? item?.userallocation  && Array.isArray(item?.userallocation) ?  item?.userallocation.map((region)=>(region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')')) : `${item?.userallocation?.regioninfo.regionName+'(' + item?.userallocation?.pipelineConfigFrom+' - '+item?.userallocation?.pipelineConfigTo + ')'}` : 'No Data',
					pipelineChainage: item?.pipelineChainage !== undefined && item?.pipelineChainage !== null? item.pipelineChainage: 'No Data'
        
				});
			});
        
			return { ...state, incidents: incidents, pending: false, error: false , pagination: pagination  };
		} else {			
                
			if (action.payload && action.payload.data.length == 0) {
                        
				return { ...state, incidents: [], pending: false, error: false };
			} else {
    
				return { ...state, incidents: [] , pending: false, error: true };
			}
		}
                
	case INCIDENT_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case INCIDENT_LIST_DETAILS:
		return { ...state, pending: true };
        
	case INCIDENT_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details:action.payload, error: false };
	case INCIDENT_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };
      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}